<template>
  <div class="news_page">
    <div class="banner">
      <img src="../assets/images/news_banner.png" alt="" />
    </div>
    <div class="btn_box">
      <div class="btn_body">
        <div class="btns">
          <!-- 	<div class="btn" :class="tabIndex===item?'btn_act':''" v-for="(item,index) in btns" :key="index"
						@click="changeTab(item)">{{item}}
					</div> -->
        </div>
        <div class="goback">
          <span @click="goback()">{{ $t("news.backToHome") }}</span> >
          <span> {{ $t("news.newsDetail") }}</span>
        </div>
      </div>
    </div>
    <div class="hyrd_box" v-show="tabIndex === 'news.industry'">
      <div class="list_box">
        <div
          class="news"
          v-for="(item, index) in newsList"
          :key="index"
          @click="jumpDetail(item)"
        >
          <div class="text">
            <div class="title">{{ item.newsHead }}</div>
            <div class="tips">
              {{ item.newsAbstract }}
            </div>
          </div>
          <div class="time">
            <div class="month">{{ item.month }}/{{ item.day }}</div>
            <div class="year">{{ item.year }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="page">
      <el-pagination
        small
        background
        layout="prev, pager, next"
        @current-change="changePage"
        :page-size="pageSize"
        :total="total"
      ></el-pagination>
    </div>
    <!-- <div class="gsdt_box" v-show="tabIndex === 'news.company'">
      <div class="list_box">
        <div class="news" v-for="(item, index) in newsList" :key="index">
          <div class="text">
            <div class="title">{{ item.newsHead }}</div>
            <div class="tips">
              {{ item.newsAbstract }}
            </div>
          </div>
          <div class="time">
            <div class="month">{{ item.month }}/{{ item.day }}</div>
            <div class="year">{{ item.year }}</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "news",
  data() {
    return {
      tabIndex: "news.industry",
      btns: ["news.industry", "news.company"],
      params: {
        pn: 1,
        rows: 5,
        type: 1,
      },
      newsList: [],
      total: 1,
      pageSize: 5,
    };
  },
  computed: {
    pageTitle() {
      return this.params.type == 2 ? "企业文化" : "新闻动态";
    },
  },
  watch: {
    "$route.query.type"(newType) {
      this.params.type = newType || 1;
      this.params.pn = 1;
      this.getNews();
    },
  },
  mounted() {
    if (this.$route.query.type) {
      this.params.type = this.$route.query.type;
    }
    this.getNews();
  },
  methods: {
    getNews() {
      this.$api.getNews(this.params).then(({ data: { data } }) => {
        this.newsList = data.list;
        this.total = data.total;
      });
    },
    jumpDetail(data) {
      this.$router.push({
        path: "/news/" + data.id,
        query: {
          type: this.params.type,
        },
      });
    },
    //分页
    changePage(pageNo) {
      this.params.pn = pageNo;
      this.getNews();
      window.scroll(0, 0);
    },
    goback() {
      this.$router.push("/Home");
    },
    changeTab(item) {
      this.tabIndex = item;
    },
  },
};
</script>
<style lang="scss" scoped>
.news_page {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;

  .banner {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }
  }

  .btn_box {
    width: 100%;
    height: 64px;
    background-color: #f0f1f5;

    .btn_body {
      width: 100%;
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btns {
        width: 50%;
        height: 64px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .btn {
          width: auto;
          padding: 5px 10px;
          box-sizing: border-box;
          background-color: rgba(255, 255, 255, 1);
          margin-right: 15px;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;

          &:hover {
            transition: all 0.3s;
            box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
          }
        }

        .btn_act {
          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
        }
      }

      .goback {
        width: auto;
        height: 64px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        span {
          cursor: pointer;

          &:last-child {
            font-weight: bold;
          }
        }
      }
    }
  }

  .hyrd_box,
  .gsdt_box {
    width: 100%;
    min-height: 300px;
    height: auto;
    box-sizing: border-box;

    .list_box {
      width: 100%;
      max-width: 1400px;
      padding: 20px 0;
      box-sizing: border-box;
      height: auto;
      margin: 0 auto;

      .news {
        width: 100%;
        margin-bottom: 20px;
        height: auto;
        background-color: #f5f5f5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: start;
        padding: 15px 30px;
        box-sizing: border-box;
        transition: all 0.3s;
        cursor: pointer;
        &:active {
          background-color: rgba(0, 0, 0, 0.1);
        }

        .text {
          width: 70%;

          .title {
            width: 100%;
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 10px;
          }

          .tips {
            width: 100%;
            font-size: 14px;
          }
        }
      }

      .time {
        color: #969495;
        text-align: end;

        .month {
          font-size: 28px;
        }
      }
    }
  }
}
.page {
  text-align: center;
  padding-bottom: 119px;
}
.news-info:hover .news-text {
  // color: #5754f2;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: white;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #49ced5;
  border-radius: 50%;
  color: #fff;
}
</style>
